import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_DELETE_QUOTA_SERVER } from '@/app/module/content/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDeleteQuota = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [deleteQuotaMutation, deleteQuotaRes] = esApi.endpoints.deleteOrgQuota.useMutation()

  const deleteQuota = useCallback(
    async (quotaId: string) => {
      if (!orgId) {
        return false
      }

      try {
        await deleteQuotaMutation({
          orgId: orgId.toString(),
          quotaId,
        }).unwrap()

        dispatch(
          createNotification({
            'delete-quota-success': {
              type: 'success',
              message: 'Quota deleted successfully.',
            },
          }),
        )
        return true
      } catch (error) {
        dispatch(
          createNotification({
            'delete-quota-error': {
              type: 'error',
              message: getErrorMessage(error, ERROR_DELETE_QUOTA_SERVER),
            },
          }),
        )
        return false
      }
    },
    [orgId, deleteQuotaMutation, dispatch],
  )

  return [deleteQuota, deleteQuotaRes] as const
}
